export function getCookie(name: string) : string | null {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`,
  ))
  return matches ? decodeURIComponent(matches[1]) : null
}

export function removeCookie(name: string) :void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
}

export function checkHasWorkShares() :boolean {
  return Boolean(Number(getCookie('DittoMusic[hasWorkShares]') || 0))
}
